import Vue from "vue";
import Router from "vue-router";
import Analytics from '@/libs/analytics/Analytics';
const analyticsObj = new Analytics();
import { isAuthenticated, getUserFromStorage } from '@/utils/Customs'

Vue.use(Router);

/**
 * Application Routes
 */
import { auth } from './auth'
import { tutorials } from './tutorials'
import { students } from './students'


import { institutions } from './institutions'

import { rooms } from './rooms'
import { insts } from './insts'

import { events } from './events'
import { evs } from './evs'
import { roos } from './roos'







import { appeals } from './appeals'
import { informations } from './informations'
import { ends } from './ends'
import { surveys } from './surveys'
import { complaints } from './complaints'
import { admincomps } from './admincomps'
import { reqqs } from './reqqs'
import { folders } from './folders'




import { users } from './users'
import { roles } from './roles'
import { analytics } from './analytics'

let appRoutes = [
  {
    path: '',
    component: () => import('@/components/layout/full/MainContainer.vue'),
    
    children: [
      {
          path: '/',
          redirect: '/home'
      },
      {
        path: "/home",
        name: "home",
        component: () => import("@/components/pages/Home.vue"),
        meta: {
          requiresAuth: true,
        }
      },
      {
        path: "/finishevent",
        name: "Etkinlik Bitir",
        component: () => import("@/components/pages/EtkinlikBitir.vue"),
        meta: {
          requiresAuth: true,
        }
      },
      {
        path: "/lastevents",
        name: "Son Etkinlikler",
        component: () => import("@/components/pages/LastEvents.vue"),
        meta: {
          requiresAuth: true,
          is_personel : true
        }
      },
      {
        path: "/newevent",
        name: "Yeni Etkinlik",
        component: () => import("@/components/pages/NewEvent.vue"),
        meta: {
          requiresAuth: true,
          is_personel : true
        }
      },
      {
        path: "/adminedit",
        name: "Admin Edit",
        component: () => import("@/components/pages/AdminEdit.vue"),
        meta: {
          requiresAuth: true,
          is_admin : true
        }
      },
      {
        path: "/dashboard",
        name: "Dashboard",
        component: () => import("@/components/pages/StarterPage.vue"),
        meta: {
          requiresAuth: true,
         
        }
      },
      
      {
        path: "/page-not-found",
        name: "page-not-found",
        component: () => import("@/components/pages/PageNotFound.vue"),
        meta: {
          requiresAuth: true,
         
        }
      },
      {
        path: "/not-authorized",
        name: "not-authorized",
        component: () => import("@/components/pages/NotAuthorized.vue"),
        meta: {
          requiresAuth: true,
         
        }
      },
      /* {
        path: "/profile",
        name: "profile",
        component: () => import("@/components/pages/Profile.vue"),
        meta: {
          requiresAuth: true,
         
        }
      }, */
      {
        path: "/prequest",
        name: "prequest",
        component: () => import("@/components/pages/Prequest.vue"),
        meta: {
          requiresAuth: true,
         
        }
      },
      {
        path: "/FolderManagement",
        name: "FolderManagement",
        component: () => import("@/components/pages/FolderManagement.vue"),
        meta: {
          requiresAuth: true,
         
        }
      },
      {
        path: "/MyActivities",
        name: "Etkinliklerim",
        component: () => import("@/components/pages/MyActivities.vue"),
        meta: {
          requiresAuth: true,
          
        }
      },
      {
        path: "/TaskManager",
        name: "Görev Atama",
        component: () => import("@/components/pages/TaskManager.vue"),
        meta: {
          requiresAuth: true,
         
        }
      },
      {
        path: "/AddTask",
        name: "addtask",
        component: () => import("@/components/pages/AddTask.vue"),
        meta: {
          requiresAuth: true,
         
        }
      },
      {
        path: "/EventQuery",
        name: "etkinlik-sonuclar",
        component: () => import("@/components/pages/EventQuery.vue"),
        meta: {
          requiresAuth: true,
        
        }
      },
      {
        path: "/SocialContribution",
        name: "SocialContribution",
        component: () => import("@/components/pages/SocialContribution.vue"),
        meta: {
          requiresAuth: true,
          is_Fakulteadmin: true,
        }
      },
      {
        path: "/SocialRoles",
        name: "SocialRoles",
        component: () => import("@/components/pages/SocialRoles.vue"),
        meta: {
          requiresAuth: true,
          is_Fakulteadmin: true,
        }
      },
      {
        path: "/SocialEvents",
        name: "SocialEvents",
        component: () => import("@/components/pages/SocialEvents.vue"),
        meta: {
          requiresAuth: true,
          is_Fakulteadmin: true,
        }
      },
      {
        path: "/SocialTasks",
        name: "SocialTasks",
        component: () => import("@/components/pages/SocialTasks.vue"),
        meta: {
          requiresAuth: true,
          is_Fakulteadmin: true,
        }
      },
      
      {
        path: "/FolderPage",
        name: "FolderPage",
        component: () => import("@/components/pages/FolderPage.vue"),
        meta: {
          requiresAuth: true,
          is_Fakulteadmin: true,
         
        }
      },
    ],
  },
  // Redirect to 404 page, if no match found
  {
    path: '*',
    redirect: '/page-not-found'
  }
];

let routeDefinitions = [];

[auth, tutorials,students, reqqs, appeals,informations,ends,surveys, users, roles, analytics, institutions, rooms, events,insts,evs,roos,complaints,admincomps,folders]
  .forEach( route => {

    routeDefinitions = routeDefinitions.concat(route);

  });

appRoutes[0].children = appRoutes[0].children.concat(routeDefinitions)

/**
 * Finally export the entire router
 */
const router = new Router({
  mode: "history",
  routes: appRoutes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  },
});

/**
 * check if user has certain role
 *
 * @param user
 * @param role
 * @returns {boolean}
 */
const userHasRole = (user, role) => { 
  let status = false
  if(user.turId=="101" || user.turId=="105" || user.adKullaniciAdi=="admin" || user.adKullaniciAdi=="gokce.ozer" || user.adKullaniciAdi=="meryem.aciksoz"){
    status=true
  }
  

  return status;
}

/**
 * update title if meta exists
 */
router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    
    
    if (! isAuthenticated()) {
      return next({
        path: '/login',
        params: { nextUrl: to.fullPath }
      })
    } else {
      let user = getUserFromStorage()
      if(to.matched.some(record => record.meta.is_admin)) {
        if( user.turId=="903" || user.adKullaniciAdi=="admin" || user.adKullaniciAdi=="gokce.ozer" || user.adKullaniciAdi=="meryem.aciksoz") {
           next()
          // allow continuation to set meta title data below
        }
        else {
          return next({ name: 'not-authorized'})
        }
      }
      else if(to.matched.some(record => record.meta.is_Sksadmin)) {
        if(user.turId=="905" || user.turId=="903" || user.adKullaniciAdi=="admin" || user.adKullaniciAdi=="gokce.ozer" || user.adKullaniciAdi=="meryem.aciksoz") {
           next()
          // allow continuation to set meta title data below
        }
        else {
          return next({ name: 'not-authorized'})
        }
      }
      else if(to.matched.some(record => record.meta.is_ogrAndidari)) {
        if(user.turId=="100" || user.turId=="905" ||  user.turId=="903" || user.adKullaniciAdi=="admin" || user.adKullaniciAdi=="gokce.ozer" || user.adKullaniciAdi=="meryem.aciksoz") {
          next()
          // allow continuation to set meta title data below
        }
        else {
          return next({ name: 'not-authorized'})
        }
      }
      else if(to.matched.some(record => record.meta.is_idari)) {
        if(user.turId=="905" || user.turId=="904" || user.turId=="903" || user.adKullaniciAdi=="admin" || user.adKullaniciAdi=="gokce.ozer" || user.adKullaniciAdi=="meryem.aciksoz") {
           next()
          // allow continuation to set meta title data below
        }
        else {
          return next({ name: 'not-authorized'})
        }
      }
      else if(to.matched.some(record => record.meta.is_personel)) {
        if(user.turId=="100" || user.turId=="101" || user.turId=="102" || user.turId=="103" || user.turId=="104" ||  user.turId=="905" || user.turId=="904" || user.turId=="903" || user.adKullaniciAdi=="admin" || user.adKullaniciAdi=="gokce.ozer" || user.adKullaniciAdi=="meryem.aciksoz") {
           next()
          // allow continuation to set meta title data below
        }
        else {
          return next({ name: 'not-authorized'})
        }
      }
      else {
        // next()
        // allow continuation to set meta title data below
      }
    }
  } else if(to.matched.some(record => record.meta.guest)) {
    if(isAuthenticated()) {
      return next({ name: 'home'})
    }
    else {
      // next()
      // allow continuation to set meta title data below
    }
  }

  if(to.hasOwnProperty('meta') && to.meta.hasOwnProperty('title')) {
    document.title = to.meta.title
    $('.breadcrumb-heading').text(to.meta.title)
  }

  analyticsObj.logTrafficFromRouter(to)

  next()
})

export default router;